import { DateTime } from 'luxon';
import { Plugin } from '../model/plugin';
import { Ref } from '../model/ref';
import { Mod } from '../model/tag';

export const voteUpPlugin: Plugin = {
  tag: 'plugin/user/vote/up',
  name: '⬆️ Vote Up',
  config: {
    mod: '⬆️ Voting',
    type: 'plugin',
    experimental: true,
    generated: $localize`Generated by jasper-ui ${DateTime.now().toISO()}`,
    description: $localize`Activates built-in voting support and allows users to upvote Refs.`,
    // language=CSS
    css: `.voting {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      max-height: 56px;
      margin-right: 10px;

      * {
        cursor: pointer;
        transition: transform 100ms ease-in-out, filter 100ms ease-in-out;
        filter: grayscale(1);
        &:hover {
          filter: grayscale(1) brightness(1.1);
        }
        &:active {
          transform: scale(0.9);
          filter: grayscale(1) brightness(0.7) blur(0.1px);
        }
      }

      .vote-up.on {
        transform: scale(1.5);
        filter: hue-rotate(180deg);
        &:hover {
          filter: brightness(1.1) hue-rotate(180deg);
        }
        &:active {
          transform: scale(0.9);
          filter: brightness(0.7) blur(0.1px) hue-rotate(180deg);
        }
      }

      .vote-down.on {
        transform: scale(1.2);
        filter: hue-rotate(0);
        &:hover {
          filter: brightness(1.1);
        }
        &:active {
          transform: scale(0.9);
          filter: brightness(0.7) blur(0.1px);
        }
      }

      .vote-up::before {
        content: '⬆️';
      }

      .vote-down::before {
        content: '⬇️';
      }
    }`
  },
};

export const voteDownPlugin: Plugin = {
  tag: 'plugin/user/vote/down',
  name: '⬇️ Vote Down',
  config: {
    mod: '⬆️ Voting',
    type: 'plugin',
    experimental: true,
    generated: $localize`Generated by jasper-ui ${DateTime.now().toISO()}`,
    description: $localize`Allows users to downvote Refs. Required upvote plugin to be installed.`,
  },
};

export function score(ref: Ref) {
  let score = 0;
  if (ref.metadata?.plugins?.['plugin/user/vote/up']) {
    score += ref.metadata?.plugins['plugin/user/vote/up'];
  }
  if (ref.metadata?.plugins?.['plugin/user/vote/down']) {
    score -= ref.metadata?.plugins['plugin/user/vote/down'];
  }
  return score;
}

export const voteMod: Mod = {
  plugin: [
    voteUpPlugin,
    voteDownPlugin,
  ],
};
